import BaseModel from './BaseModel';

export default class Restaurant extends BaseModel {

}
